<div class="w-full flex flex-col gap-[0.75rem] px-[0.75rem] sm:px-[1rem] pb-3 sm:pb-(--date-selection-reserved-height-for-sm-and-md) lg:pb-0"
     [gcElementWidthClass]=""
     [gcElementWidthClassIsActive]="!floatingPopupService.isMobileMode()">
  @let deployment = data()?.loggerDeployment;

  @if (data()) {
    @if (loggerType(); as type) {
      <gc-ld-logger-noise-type-icon-with-score
        [loggerType]="type"
        [leakScore]="leakScore()"
        [leakScoreStatus]="leakScoreStatus()"
        [leakDetectionMode]="leakDetectionMode()">
      </gc-ld-logger-noise-type-icon-with-score>
    }

    <div class="flex flex-col items-start">
      <div class="grid
        grid-cols-[1fr]
        md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]
        lg:grid-cols-[1fr]
        gap-[0.25rem]
        md:gap-[2.5rem]
        lg:gap-[0.25rem]
        [.is-md_&]:!grid-cols-[minmax(0,1fr)_minmax(0,1fr)]
        [.is-md_&]:!gap-[2.5rem]
        w-full
        max-w-[62.5rem]">
        <div class="flex flex-col gap-[0.25rem] items-start">
          <gc-label-value-presentation [label]="'@@shared-sound-signal__text' | translate">
            <gc-ld-logger-noise-sound-signal-load
              class="max-h-[1.125rem]"
              [soundSignalId]="soundSignalId()"
              [soundSignalUrl]="soundSignalUrl()"
              [showDownloadAlways]="true">
            </gc-ld-logger-noise-sound-signal-load>
          </gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-logger__text' | translate">{{serialNo()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-min-noise__text' | translate">{{lowestNoiseDecibel()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-spread__text' | translate">{{spread()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-start-time__text' | translate">{{measStartTime()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-sound-signal-start__text' | translate">{{soundSignalStartAt()}}</gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-latitude-longitude__text' | translate">{{latitudeLongitude()}}</gc-label-value-presentation>

          @let coordinatesLabelText = coordinatesLabel();

          <gc-label-value-presentation [label]="coordinatesLabelText.key | translate: coordinatesLabelText.params">{{coordinates()}}</gc-label-value-presentation>
        </div>

        <div class="flex flex-col gap-[0.25rem] items-start">
          <gc-label-value-presentation [label]="'@@shared-location__text' | translate">{{location()}}</gc-label-value-presentation>

          @let isCommentExist = !!deployment?.comment;
          <gc-label-value-presentation [label]="'@@shared-comments' | translate" [stacked]="true">
            @if (isCommentExist) {
              <gc-comment-card
                [authorName]="commentAuthor()"
                [authorDate]="commentModifiedAt()"
                [message]="comment()"
                [showBorder]="true"
                [showReadMoreButton]="true"
                [truncateMessage]="true"
                (readMore)="changeToCommentTab()">
              </gc-comment-card>
            } @else {
              <gc-comment-card-no-data
                [addPermissions]="[PermissionName.LeakDetection_Write_Comments]"
                (add)="changeToCommentTab()">
              </gc-comment-card-no-data>
            }
          </gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-env-noise__text' | translate">
            <gc-ld-logger-noise-env-noise-edit
              class="max-h-[1.125rem]"
              [value]="envNoiseValue()"
              [serialNo]="rawSerialNo()"
              popoverStyleClass="z-app-overlay-10">
            </gc-ld-logger-noise-env-noise-edit>
          </gc-label-value-presentation>

          <gc-label-value-presentation [label]="'@@shared-serving-cell-id__text' | translate">
            <gc-ld-logger-noise-serving-cell-id class="max-h-[1.125rem]" [servingCellId]="servingCellId()"></gc-ld-logger-noise-serving-cell-id>
          </gc-label-value-presentation>
        </div>
      </div>
    </div>

    <div *ngxPermissionsOnly="[PermissionName.LeakDetection_Read_DeveloperColumns]" class="flex flex-col items-start border-t border-(--p-blue-50) mb-4 pt-3">
      <div class="grid
        grid-cols-[1fr]
        md:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]
        lg:grid-cols-[1fr]
        gap-[0.25rem]
        md:gap-[2.5rem]
        lg:gap-[0.25rem]
        [.is-md_&]:!grid-cols-[minmax(0,1fr)_minmax(0,1fr)]
        [.is-md_&]:!gap-[2.5rem]
        w-full
        max-w-[62.5rem]">
        <div class="flex flex-col gap-[0.25rem] items-start">
          <gc-label-value-presentation [highlight]="true" [label]="'@@shared-ecl__text' | translate">
            <gc-ld-logger-noise-ecl-indicator class="max-h-[1.125rem]" [ecl]="eclValue()"></gc-ld-logger-noise-ecl-indicator>
          </gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-channel-cell__label' | translate">{{channelAndCell()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-round-trip-time__label' | translate">{{roundTripTime()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-band-used__label' | translate">{{bandUsed()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-sc-pci__label' | translate">{{scPci()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-sc-pci-state__label' | translate">{{scPciState()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-cell-time__label' | translate">{{cellTime()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-sync-time__label' | translate">{{syncTime()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-connection-time__label' | translate">{{connectionTime()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-signal-type__label' | translate">{{signalType()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-sound-signal-sampling-freq__label' | translate">{{soundSignalSamplingFrequency()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-ls-1-4__label' | translate">{{ls1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-db-over__label' | translate">{{dBover()}}</gc-label-value-presentation>
        </div>

        <div class="flex flex-col gap-[0.25rem] items-start">
          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-f-rated-1-4__label' | translate">{{fRated1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-f-peaks-1-4__label' | translate">{{fPeaks1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-dyn-1-4__label' | translate">{{dyn1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-periodicity__label' | translate">{{periodicity()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-fac-correls__label' | translate">{{facCorrels()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-l1-1-4__label' | translate">{{l1_1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-l3-1-4__label' | translate">{{l3_1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-l4-1-4__label' | translate">{{l4_1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-l5-1-4__label' | translate">{{l5_1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-l6-1-4__label' | translate">{{l6_1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-l7-1-4__label' | translate">{{l7_1_4()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-ccount__label' | translate">{{ccount()}}</gc-label-value-presentation>

          <gc-label-value-presentation [highlight]="true" [label]="'@@ld-logger-noise-spectrum-std-dev__label' | translate">{{spectrumStdDev()}}</gc-label-value-presentation>
        </div>
      </div>
    </div>
  }
</div>
